import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolBlockSchema,
} from "../commonSchema";

const defaultGifBlockStyleAttributes = {
  src: "",
  padding: "25px 25px 25px 25px",
  "fluid-on-mobile": "false" as const,
  containerWidth: 600,
};

export const TopolGifBlockStyleAttributesSchema = z.object({
  padding: z.string().catch(defaultGifBlockStyleAttributes["padding"]),
  align: TopolBlockAlignSchema.optional().catch(undefined),
  "fluid-on-mobile": z
    .enum(["true", "false"])
    .catch(defaultGifBlockStyleAttributes["fluid-on-mobile"]),
  "border-radius": z.string().optional().catch(undefined),
});

export const TopolGifBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-gif"),
  attributes: z
    .object({
      src: z.string().trim().catch(""),
      alt: z.string().optional().catch(undefined),
      href: z.string().trim().optional().catch(undefined),
      ...TopolGifBlockStyleAttributesSchema.shape,
      containerWidth: z
        .number()
        .catch(defaultGifBlockStyleAttributes["containerWidth"]),
      width: z.string().or(z.number()).optional().catch(undefined),
      widthPercent: z.number().optional().catch(undefined),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .default(defaultGifBlockStyleAttributes),
});

export type TopolGifBlock = z.infer<typeof TopolGifBlockSchema>;
